import { createFileRoute } from '@tanstack/react-router';

import { GHGTasksMatrixPage } from '@/features/ghg/components/GHGTasksMatrixPage';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/ghg/tasks')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.tasks'),
  }),
  component: TasksPage,
});

function TasksPage() {
  return <GHGTasksMatrixPage />;
}
